import { memo, useMemo } from "react"
import { DgtPdProductionOrder } from "../models"
import Badge from '../components/Badge'
import { formatDate, formatNumberV2 } from "../utilities/Format"
import { convertJson } from "../utilities/Validate"

const OrderHeader = ({ order } : {
  order: DgtPdProductionOrder
}) => {
  const batchLots = useMemo(() => {
    let batchNumbers: string[] = []
    if (order.actualBatchNumbers) {
      const actualBatchNumbers : string[] = convertJson(order.actualBatchNumbers)

      const originalBatch : string[] = convertJson(order.batchNumbers)

      actualBatchNumbers.forEach(batch => {
        const sixLastDigit = batch.slice(-6)
        const matchSuffix = originalBatch.find(b => b.slice(-6) === sixLastDigit)
        if (matchSuffix) batchNumbers.push(batch)
      })

      originalBatch.forEach(origin => {
        if (!batchNumbers.map(b => b.slice(-6)).includes(origin.slice(-6))) batchNumbers.push(origin)
      })
      return Array.from(new Set(batchNumbers))
    } else if (order.batchNumbers) {
      return convertJson(order.batchNumbers)
    }
    return []
  }, [ order ])

  return (
    <>
      <div className={`grid gap-1 grid-cols-1 sm:grid-cols-3 transition-all duration-700 max-h-40 overflow-auto`}>
        <div className='flex col-span-2'>
          <h6 className='font-bold basis-1/4'>Order</h6>
          <h6 className="basis-3/4">{order.id}</h6>
        </div>
        <div className='flex'>
          <h6 className='font-bold basis-1/4 sm:basis-2/4 lg:basis-1/3'>Type</h6>
          <h6 className='basis-3/4 sm:basis-2/4 lg:basis-2/3'>
            {order.orderType === 'REPACK' && <Badge variant="order-repack"><>{order.orderType}</></Badge>}
            {order.orderType === 'CLAIM' && <Badge variant="order-claim"><>{order.orderType}</></Badge>}
            {order.orderType === 'FG' && <Badge variant="order-normal"><>{order.orderType}</></Badge>}
          </h6>
        </div>
        <div className='flex col-span-2'>
          <h6 className='font-bold basis-1/4'>Material</h6>
          <div className='flex basis-3/4'>
            {order ? <div>
              <h6>{order.materialDescription} ({order.materialCode}) {order.barcodeFgCase ? `(${order.barcodeFgCase})` : null} ({order.division})</h6>
              <div className='flex flex-wrap gap-1'>
                {order.infoFwt && <Badge variant='product-info'>{order.infoFwt}</Badge>}
                {order.infoEffBulkDate && <Badge variant='product-info'>{`Eff.Bulk : ${order.infoEffBulkDate}`}</Badge>}
                {order.infoRefPkg && <Badge variant='product-info'>{order.infoRefPkg}</Badge>}
                {order.infoPallet && <Badge variant='product-info'>{`Pallet: ${order.infoPallet}`}</Badge>}
                {order.infoPacking && <Badge variant='product-info'>{`Packing: ${order.infoPacking}`}</Badge>}
              </div>
            </div> : null}
          </div>
        </div>
        <div className='flex'>
          <h6 className='font-bold basis-1/4 sm:basis-2/4 lg:basis-1/3'>Order Qty.</h6>
          {order ? <h6 className='basis-3/4 sm:basis-2/4 lg:basis-2/3'>{formatNumberV2(order.orderQty)} {order.materialUnit}</h6> : null}
        </div>
        <div className='flex col-span-2'>
          <h6 className='font-bold basis-1/4'>Batch No</h6>
          <h6 className="basis-3/4">{batchLots.join(', ')}</h6>
        </div>
        <div className='flex'>
          <h6 className='font-bold basis-1/4 sm:basis-2/4 lg:basis-1/3'>Due Date</h6>
          <h6 className='basis-3/4 sm:basis-2/4 lg:basis-2/3'>{formatDate(order.dueDate)}</h6>
        </div>
      </div>
    </>
  )
}

export default memo(OrderHeader)